<template>
  <div>
    <div class="vehicle-capacity-bars">
      <div class="bars">
        <div
          v-for="(bar, index) in computedBars"
          :key="index"
          :style="{ backgroundColor: bar.color, width: bar.width + '%' }"
          class="bar"
        >
          {{ bar.value }}
        </div>
      </div>
      <div class="bars">
        <div
          v-for="(bar, index) in comparedBars"
          :key="index"
          :style="{ 
            backgroundColor: bar.color, 
            width: bar.width + '%',
            marginRight: bar.color === 'green' ? 'auto' : '2px'
          }"
          class="bar"
        >
          {{ bar.value === 'Empty' ? '0' : bar.value }}
        </div>
        <div 
          v-if="remainingSpace > 0"
          class="remaining-space"
          :style="{ width: (remainingSpace / maxValue) * 100 + '%' }"
        ></div>
      </div>
    </div>
    <div class="totals">Total: {{ total }}</div>
  </div>
</template>

<script>
export default {
  name: "VehicleCapacityBars",
  props: {
    total: {
      type: Number,
      default: 0,
    },
    plannedTasks: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    maxValue() {
      const sumOrderQty = this.plannedTasks.reduce((acc, task) => acc + task.order_qty, 0);
      return  sumOrderQty
      //return Math.max(sumOrderQty, this.total);
    },


    remainingSpace() {
      const usedSpace = this.comparedBars.reduce((acc, bar) => {
        return acc + (bar.value === 'Empty' ? 0 : Number(bar.value));
      }, 0);
      return this.maxValue - usedSpace;
    },
    computedBars() {
      return this.plannedTasks.map((task) => ({
        color: "grey",
        value: task.order_qty,
        width: (task.order_qty / this.maxValue) * 100,
      }));
    },
    comparedBars() {
      return this.plannedTasks.map((task) => {

        if (task.pickup_qty === 0 && task.pickup_date !== null) {
          return {
            color: "blue",
            value: "Empty",
            width: 0,
          };
        }

        const color =
          task.pickup_qty >= task.order_qty
            ? "green"
            : task.pickup_qty > 0
            ? "red"
            : "grey";

        const width =
          // task.pickup_qty === null && task.pickup_date === null
          color === "grey"
            ? (task.order_qty / this.maxValue) * 100
            : (task.pickup_qty / this.maxValue) * 100;

        return {
          color,
          value: task.pickup_qty || task.order_qty,
          width: width,
        };
      });
    },
  },
};
</script>


<style scoped>
.vehicle-capacity-bars {
  border: 3px solid #ccc;
  padding: 10px;
  border-radius: 10px;
  position: relative;
  text-align: center;
}

.bars {
  display: flex;
  justify-content: flex-start;
  border-radius: 5px;
  overflow: hidden;
  background-color: #f5f5f5;
  box-sizing: border-box;
  width: 100%;

}

.bar {
  color: white;
  padding: 5px;
  margin: 2px;
  text-align: center;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;

}

.bar[style*="blue"] {
  opacity: 0.8;
}

.remaining-space {
  background-color: transparent;

  border-radius: 5px;
}


.totals {
  margin-top: 10px;
  text-align: center;
  font-weight: bold;
}
</style>